/** @format */

import { RootState } from "../store/store";

export const selectCurrentCircle = (state: RootState) =>
	state.circle.circleInfo;

export const selectedCurrentCircleInfo = (state: RootState) =>
	state.circle.circleInfo;

export const selectCircleData = (state: RootState) =>
	state.circle.circleDataAccess;

export const selectIsLoading = (state: RootState) => state.circle.isLoading;

export const selectCircleCurrency = (state: RootState) =>
	state.circle.circleDataAccess?.configuration?.currency || "usd";

export const selectAllCircles = (state: RootState) => {
	const circleInfo = state.circle.circleInfo;
	if (Array.isArray(circleInfo)) {
		return circleInfo;
	}
	// Handle case where API returns { circles: [...] } object
	if (circleInfo && typeof circleInfo === "object" && "circles" in circleInfo) {
		return (circleInfo as any).circles || [];
	}
	return [];
};

export const selectCircleError = (state: RootState) => state.circle.error;

export const selectLeaderSendAddRequestMessage = (state: RootState) =>
	state.circle.leaderSendAddRequestInfo?.message;

export const selectViewSendAddRequest = (state: RootState) =>
	state.circle.viewAndSearchAddRequestData;

export const selectJoinRequestSuccessMessage = (state: RootState) =>
	state.circle.joinRequestSuccessMessage;

export const selectJoinRequestErrorMessage = (state: RootState) =>
	state.circle.joinRequestErrorMessage;

export const selectJoinRequestsOfCircle = (state: RootState) =>
	state.circle.joinRequestOfCircleByCircleLeaderIdResult;

export const selectCircleStripeConnectedAccountBalance = (state: RootState) =>
	state.circle.circleStripeConnectedAccountBalance;

export const selectCircleExpectedTotalPayOut = (state: RootState) =>
	state.circle.circleExpectedTotalPayOut;

export const selectJointRequestUserSent = (state: RootState) =>
	state.circle.joinRequestUserSent;

export const selectUnionCycleBalances = (state: RootState) =>
	state.circle.unionCycleBalances;

export const selectAllCircleStats = (state: RootState) =>
	state.circle.allCirclesCurrentMonthContribution;

export const selectAllCirclesContributionHistory = (state: RootState) =>
	state.circle.allCirclesContributionHistory;

export const selectContributionsChartData = (state: RootState) =>
	state.circle.contributionsChartData;

export const selectUnionLeaderApplications = (state: RootState) =>
	state.circle.unionLeaderApplications;

export const selectIsLoadingApplications = (state: RootState) =>
	state.circle.isLoadingApplications;

export const selectIsApprovingApplication = (state: RootState) =>
	state.circle.isApprovingApplication;

export const selectIsRejectingApplication = (state: RootState) =>
	state.circle.isRejectingApplication;

export const selectIsDeletingApplication = (state: RootState) =>
	state.circle.isDeletingApplication;

export const selectApplicationError = (state: RootState) =>
	state.circle.applicationError;

// Admin selectors
export const selectAdminCircles = (state: RootState) =>
	state.circle.adminCircles || [];

export const selectAdminCircleById = (id: string) => (state: RootState) =>
	(state.circle.adminCircles || []).find((c) => c._id === id) ||
	state.circle.circleInfo.find((c) => c._id === id) ||
	null;

export const selectAdminIsLoading = (state: RootState) =>
	state.circle.isLoading;

export const selectAdminError = (state: RootState) => state.circle.error;

// Admin Join Request selectors
export const selectJoinRequestsApplications = (state: RootState) =>
	state.circle.joinRequestsApplications;

export const selectIsLoadingJoinRequests = (state: RootState) =>
	state.circle.isLoadingJoinRequests;

export const selectIsApprovingJoinRequest = (state: RootState) =>
	state.circle.isApprovingJoinRequest;

export const selectIsRejectingJoinRequest = (state: RootState) =>
	state.circle.isRejectingJoinRequest;

export const selectJoinRequestError = (state: RootState) =>
	state.circle.joinRequestError;

export const selectJoinRequestsCount = (state: RootState) =>
	state.circle.joinRequestsApplications?.totalCount || 0;

export const selectPendingJoinRequests = (state: RootState) =>
	state.circle.joinRequestsApplications?.joinRequests.filter(
		(req) => req.status === "Pending",
	) || [];

export const selectApprovedJoinRequests = (state: RootState) =>
	state.circle.joinRequestsApplications?.joinRequests.filter(
		(req) => req.status === "Approved",
	) || [];

export const selectRejectedJoinRequests = (state: RootState) =>
	state.circle.joinRequestsApplications?.joinRequests.filter(
		(req) => req.status === "Rejected",
	) || [];

// Admin Add Request selectors
export const selectAddRequestsApplications = (state: RootState) =>
	state.circle.addRequestsApplications;

export const selectIsLoadingAddRequests = (state: RootState) =>
	state.circle.isLoadingAddRequests;

export const selectIsApprovingAddRequest = (state: RootState) =>
	state.circle.isApprovingAddRequest;

export const selectIsRejectingAddRequest = (state: RootState) =>
	state.circle.isRejectingAddRequest;

export const selectAddRequestError = (state: RootState) =>
	state.circle.addRequestError;

export const selectAddRequestsCount = (state: RootState) =>
	state.circle.addRequestsApplications?.count || 0;

export const selectPendingAddRequests = (state: RootState) =>
	state.circle.addRequestsApplications?.data.filter(
		(req) => req.status === "Pending",
	) || [];

export const selectApprovedAddRequests = (state: RootState) =>
	state.circle.addRequestsApplications?.data.filter(
		(req) => req.status === "Approved",
	) || [];

export const selectRejectedAddRequests = (state: RootState) =>
	state.circle.addRequestsApplications?.data.filter(
		(req) => req.status === "Rejected",
	) || [];
export const selectCirclePayoutOrder = (state: RootState) =>
	state.circle.circlePayoutOrder;

export const selectIsLoadingPayoutOrder = (state: RootState) =>
	state.circle.isLoadingPayoutOrder;

export const selectPayoutOrderError = (state: RootState) =>
	state.circle.payoutOrderError;